/**
 * Directory state with type-safe invariant:
 * - Open directories MUST have a flexGrow value
 * - Closed directories always have flexGrow = 0
 */
export type DirectoryState =
  | { isOpen: true; flexGrow: number }
  | { isOpen: false; flexGrow: 0 };

/**
 * Helper to get flex-grow value safely
 */
export function getFlexGrow(state: DirectoryState): number {
  return state.isOpen ? state.flexGrow : 0;
}
